import { each } from 'lodash';

// Sequence matters here. 'Ու' comes before 'Ո', so that it's mapped properly
const letterMapping = {
  Ու: 'U',
  Ա: 'A',
  Բ: 'B',
  Գ: 'G',
  Դ: 'D',
  Ե: 'Ye',
  Զ: 'Z',
  Է: 'E',
  Ը: 'Y',
  Թ: 'T',
  Ժ: 'Zh',
  Ի: 'I',
  Լ: 'L',
  Խ: 'Kh',
  Ծ: 'Ts',
  Կ: 'K',
  Հ: 'H',
  Ձ: 'Dz',
  Ղ: 'Gh',
  Ճ: 'Tsh',
  Մ: 'M',
  Յ: 'Y',
  Ն: 'N',
  Շ: 'Sh',
  Ո: 'Vo',
  Չ: 'Ch',
  Պ: 'P',
  Ջ: 'J',
  Ռ: 'R',
  Ս: 'S',
  Վ: 'V',
  Տ: 'T',
  Ր: 'R',
  Ց: 'Ts',
  Փ: 'P',
  Ք: 'K',
  Օ: 'O',
  Ֆ: 'F',

  ու: 'u',
  ա: 'a',
  բ: 'b',
  գ: 'g',
  դ: 'd',
  ե: 'e',
  զ: 'z',
  է: 'e',
  ը: 'y',
  թ: 't',
  ժ: 'zh',
  ի: 'i',
  լ: 'l',
  խ: 'kh',
  ծ: 'ts',
  կ: 'k',
  հ: 'h',
  ձ: 'dz',
  ղ: 'gh',
  ճ: 'tsh',
  մ: 'm',
  յ: 'y',
  ն: 'n',
  շ: 'sh',
  ո: 'o',
  չ: 'ch',
  պ: 'p',
  ջ: 'j',
  ռ: 'r',
  ս: 's',
  վ: 'v',
  տ: 't',
  ր: 'r',
  ց: 'ts',
  փ: 'p',
  ք: 'k',
  և: 'ev',
  օ: 'o',
  ֆ: 'f',
  ւ: 'v',

  '\\-': '-',
  ' ': ' ',
  '/': '/',
  '\\.': '.',
};

const wordMapping = {
  քս: 'x',
  'բն\\.': 'Apt.',
  'շ\\.': 'Bld.',
  'տ\\.': 'House',
  'փ\\.': 'Str.',
  'պող\\.': 'Ave.',
  'նրբ\\.': 'Ln.',
  'թղմ\\.': 'Distr.',
  'շրջ\\.': 'Reg.',
  'միկրոշրջ\\.': 'Microreg.',
  'փկղ\\.': 'Dlock.',
};

export const getEngName = (value) => {
  if (!value) {
    return '';
  }
  let engName = value;
  engName = engName.slice(0, 1).toLocaleUpperCase() + engName.slice(1).toLocaleLowerCase();
  each(letterMapping, (en, am) => {
    engName = engName.replace(new RegExp(am, 'g'), en);
  });

  return engName;
};

export const translitEngStreet = (value) => {
  if (!value) {
    return '';
  }
  let engStreet = value;
  engStreet = engStreet.slice(0, 1).toLocaleUpperCase() + engStreet.slice(1);

  each(wordMapping, (en, am) => {
    engStreet = engStreet.replace(new RegExp(am, 'g'), en);
  });

  each(letterMapping, (en, am) => {
    engStreet = engStreet.replace(new RegExp(am, 'g'), en);
  });

  engStreet = engStreet.replace('․', '.'); // fix armenian dot bug

  return engStreet;
};

const englishWordMapping = {
  x: 'քս',
  'Apt.': 'բն.',
  'Bld.': 'շ.',
  House: 'տ.',
  'Str.': 'փ.',
  Avenue: 'Պողոտա',
  avenue: 'պողոտա',
  'Ave.': 'պող.',
  'Ln.': 'նրբ.',
  'Distr.': 'թղմ.',
  'Reg.': 'շրջ.',
  'Microreg.': 'միկրոշրջ.',
  'Dlock.': 'փկղ.',
};

const englishLetterMapping = {
  Ry: 'ՐՅ',
  ry: 'րյ',
  Ya: 'ՅԱ',
  ya: 'յա',
  Ci: 'ՑԻ',
  ci: 'ցի',
  Eg: 'ԷՋ',
  eg: 'էջ',
  Wo: 'Ո',
  wo: 'ո',
  Ay: 'Այ',
  ay: 'այ',
  U: 'Ու',
  A: 'Ա',
  B: 'Բ',
  C: 'Ց',
  c: 'ց',
  G: 'Գ',
  D: 'Դ',
  Ye: 'Ե',
  ye: 'ե',
  E: 'Ե',
  e: 'ե',
  Z: 'Զ',
  Y: 'Ը',
  y: 'ը',
  Zh: 'Ժ',
  I: 'Ի',
  L: 'Լ',
  Kh: 'Խ',
  Ts: 'Ծ',
  ts: 'ծ',
  K: 'Կ',
  H: 'Հ',
  Dz: 'Ձ',
  dz: 'ձ',
  Gh: 'Ղ',
  Tsh: 'Ճ',
  M: 'Մ',
  N: 'Ն',
  Sh: 'Շ',
  sh: 'շ',
  Vo: 'Ո',
  Ch: 'Չ',
  P: 'Պ',
  J: 'Ջ',
  j: 'ջ',
  S: 'Ս',
  V: 'Վ',
  T: 'Տ',
  t: 'տ',
  R: 'Ր',
  r: 'ր',
  O: 'Օ',
  F: 'Ֆ',
  u: 'ու',
  a: 'ա',
  b: 'բ',
  g: 'գ',
  d: 'դ',
  z: 'զ',
  zh: 'ժ',
  i: 'ի',
  l: 'լ',
  kh: 'խ',
  k: 'կ',
  h: 'հ',
  gh: 'ղ',
  tsh: 'ճ',
  m: 'մ',
  n: 'ն',
  ch: 'չ',
  p: 'պ',
  s: 'ս',
  v: 'վ',
  q: 'ք',
  ev: 'և',
  o: 'օ',
  f: 'ֆ',
  w: 'վ',
  W: 'Վ',
};
export const translitArmStreet = (value) => {
  if (!value) {
    return '';
  }
  let armStreet = value;
  armStreet = armStreet.slice(0, 1) + armStreet.slice(1);

  each(englishWordMapping, (am, en) => {
    armStreet = armStreet.replace(new RegExp(en, 'g'), am);
  });

  if (!Object.keys(englishWordMapping).includes(value)) {
    each(englishLetterMapping, (am, en) => {
      armStreet = armStreet.replace(new RegExp(en, 'g'), am);
    });
  }

  armStreet = armStreet.replace('․', '.'); // fix armenian dot bug

  return armStreet;
};
